import { useState, type SyntheticEvent as ReactSyntheticEvent } from 'react'
import { XIcon } from '../icons'
import type { KanbanBoard } from '../types'
import { API_URL, getAuthHeaders } from '../api'

export function EditBoardModal({ board, workspaceId, onUpdate, onClose }: { board: KanbanBoard; workspaceId?: string; onUpdate: (b?: KanbanBoard) => void; onClose: () => void }) {
  const [name, setName] = useState(board.name || '')
  const [saving, setSaving] = useState(false)
  const authHeaders = getAuthHeaders()

  const handleSave = async (e: ReactSyntheticEvent) => {
    e.preventDefault()
    if (!name.trim() || !workspaceId) return
    setSaving(true)
    try {
      const res = await fetch(`${API_URL}/api/workspaces/${workspaceId}/boards/${board.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeaders },
        body: JSON.stringify({ name: name.trim() }),
      })
      const data = await res.json()
      if (res.ok && data.board) {
        onUpdate(data.board)
        onClose()
      }
    } catch { /* ignore */ }
    setSaving(false)
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
        <div className="modal-header">
          <h3>Editar Workboard</h3>
          <button className="icon-btn" onClick={onClose} title="Fechar"><XIcon size={18} /></button>
        </div>
        <form onSubmit={handleSave} className="hermes-form">
          <div className="settings-field">
            <label>Nome</label>
            <input
              autoFocus
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="hermes-input"
              placeholder="Nome do workboard"
            />
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
            <button type="button" className="btn-ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={saving || !name.trim()}>
              {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
